import React from "react";
import memoize from "utils/memoize";

const LocationIcon = ({
  strokeWidth = 0.75,
  ...restProps
}: React.ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="19"
    viewBox="0 0 14 19"
    fill="none"
    {...restProps}
  >
    <path
      d="M7.17852 10.2546C5.56371 10.2546 4.25439 8.9172 4.25439 7.27552C4.25439 5.63383 5.56371 4.30273 7.17852 4.30273C8.79334 4.30273 10.1089 5.63383 10.1089 7.27552C10.1089 8.9172 8.79334 10.2546 7.17852 10.2546ZM7.17852 4.77813C5.82557 4.77813 4.72201 5.90005 4.72201 7.27552C4.72201 8.65098 5.82557 9.77924 7.17852 9.77924C8.53148 9.77924 9.64127 8.65732 9.64127 7.27552C9.64127 5.89371 8.53771 4.77813 7.17852 4.77813Z"
      fill="white"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <path
      d="M7.17832 18C7.11598 18 7.05363 17.9746 7.00999 17.9239C3.53096 14.1398 2.09072 11.3699 1.49217 9.70917C1.49217 9.70283 1.46724 9.65846 1.45477 9.60776C1.31137 9.20843 1.1929 8.80276 1.11185 8.41611L1.07444 8.2006C1.0308 7.90268 1.00586 7.60477 1.00586 7.27517C1.00586 3.81432 3.77412 1 7.17832 1C10.5825 1 13.357 3.81432 13.357 7.27517C13.357 7.60477 13.3383 7.90268 13.2947 8.19426L13.2573 8.40343C13.1762 8.77741 13.0578 9.19575 12.9019 9.64579C12.9019 9.6648 12.8894 9.69016 12.8707 9.72819C12.2722 11.3826 10.8257 14.1462 7.35913 17.9239C7.31549 17.9746 7.25314 18 7.19079 18H7.17832ZM7.17832 1.47539C4.02974 1.47539 1.47347 4.0742 1.47347 7.27517C1.47347 7.57942 1.49217 7.85831 1.53582 8.12453L1.57323 8.32737C1.64805 8.68233 1.76027 9.07532 1.90367 9.47465C1.93485 9.55071 1.92861 9.53803 1.93485 9.55071C2.50845 11.1417 3.88634 13.7912 7.18456 17.4232C10.489 13.7849 11.8669 11.1417 12.4405 9.55071C12.4467 9.53169 12.4592 9.51268 12.4654 9.5C12.6151 9.06264 12.7273 8.66965 12.8021 8.32737L12.8395 8.13087C12.8769 7.87099 12.8956 7.5921 12.8956 7.28785C12.8894 4.0742 10.3269 1.47539 7.17832 1.47539ZM7.17832 10.2543C5.56351 10.2543 4.2542 8.91685 4.2542 7.27517C4.2542 5.63348 5.56351 4.30239 7.17832 4.30239C8.79314 4.30239 10.1087 5.63348 10.1087 7.27517C10.1087 8.91685 8.79314 10.2543 7.17832 10.2543ZM7.17832 4.77778C5.82537 4.77778 4.72181 5.8997 4.72181 7.27517C4.72181 8.65063 5.82537 9.7789 7.17832 9.7789C8.53128 9.7789 9.64108 8.65697 9.64108 7.27517C9.64108 5.89336 8.53751 4.77778 7.17832 4.77778Z"
      fill="white"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <path
      d="M7.17852 10.2546C5.56371 10.2546 4.25439 8.9172 4.25439 7.27552C4.25439 5.63383 5.56371 4.30273 7.17852 4.30273C8.79334 4.30273 10.1089 5.63383 10.1089 7.27552C10.1089 8.9172 8.79334 10.2546 7.17852 10.2546ZM7.17852 4.77813C5.82557 4.77813 4.72201 5.90005 4.72201 7.27552C4.72201 8.65098 5.82557 9.77924 7.17852 9.77924C8.53148 9.77924 9.64127 8.65732 9.64127 7.27552C9.64127 5.89371 8.53771 4.77813 7.17852 4.77813Z"
      fill="white"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <path
      d="M12.6785 9.81077C12.6785 9.81077 12.6223 9.81077 12.5974 9.7981C12.4789 9.75373 12.4166 9.62062 12.4602 9.49385C12.6099 9.06282 12.7283 8.6635 12.7969 8.32121C12.8219 8.19444 12.9466 8.11204 13.0712 8.1374C13.1959 8.16275 13.277 8.28318 13.2583 8.40995C13.1835 8.83464 13.065 9.25298 12.8967 9.66499C12.8593 9.76007 12.772 9.81077 12.6785 9.81077Z"
      fill="white"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <path
      d="M1.30499 8.39719C1.19276 8.39719 1.093 8.31479 1.0743 8.2007C0.97454 7.5922 1.00571 7.28161 1.01195 7.24358C1.03065 7.11047 1.14288 7.02173 1.27381 7.03441C1.40474 7.05342 1.49203 7.16751 1.47956 7.30062C1.47956 7.30062 1.44839 7.57952 1.54191 8.1183C1.56061 8.24507 1.47956 8.37184 1.34863 8.39086C1.33616 8.39086 1.32369 8.39086 1.31122 8.39086L1.30499 8.39719Z"
      fill="white"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <path
      d="M13.0594 8.39672C13.0594 8.39672 13.0344 8.39672 13.022 8.39672C12.8973 8.37136 12.81 8.25093 12.8287 8.12416C12.916 7.58538 12.891 7.31282 12.891 7.30649C12.8786 7.17972 12.9659 7.05928 13.0968 7.04027C13.2215 7.02759 13.34 7.11633 13.3587 7.2431C13.3587 7.27479 13.3961 7.59172 13.2963 8.20022C13.2776 8.31432 13.1778 8.39672 13.0656 8.39672H13.0594Z"
      fill="white"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
  </svg>
);

export default memoize(LocationIcon);
